<div class="collage-editor">
  <!-- A div, not <header>: the theme styles every <header> element app-wide (pages/_timeline.scss). -->
  <div class="ce-header">
    <div class="ce-heading">
      <mat-icon class="ce-heading-icon">photo_library</mat-icon>
      <div class="ce-heading-text">
        <h2 mat-dialog-title class="ce-title">Build collage</h2>
        <p class="ce-subtitle">{{data.sectionLabel}}</p>
      </div>
    </div>
    <button mat-icon-button type="button" class="ce-close" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="ce-body">
    <aside class="ce-panel">
      <section class="ce-group">
        <h3 class="ce-group-title">Size</h3>
        <div class="ce-size-fields">
          <mat-form-field appearance="outline" class="ce-field">
            <mat-label>Width (px)</mat-label>
            <input matInput type="number" [(ngModel)]="widthPx" (change)="applySize()">
          </mat-form-field>
          <mat-form-field appearance="outline" class="ce-field">
            <mat-label>Height (px)</mat-label>
            <input matInput type="number" [(ngModel)]="heightPx" (change)="applySize()">
          </mat-form-field>
        </div>
        <p class="ce-hint">Height is the space left on the report page for this gallery.</p>
        <button mat-stroked-button type="button" class="ce-full-page" [disabled]="generating" (click)="useFullPageHeight()">
          <mat-icon>fit_screen</mat-icon> Use full page height ({{fullPageHeightPx}}px)
        </button>
      </section>

      <section class="ce-group">
        <h3 class="ce-group-title">Design</h3>
        <div class="ce-design">
          <span class="ce-design-name">{{templateName || '—'}}</span>
          <button mat-stroked-button type="button" [disabled]="generating" (click)="rearrange()">
            <mat-icon>shuffle</mat-icon> Next design
          </button>
        </div>
      </section>

      <section class="ce-group" *ngIf="!generating">
        <h3 class="ce-group-title">Photo order <span class="ce-count">{{thumbnailUrls.length}}</span></h3>
        <p class="ce-hint">Drag to reorder. Photo 1 is the large "hero" tile in Mosaic and Big Feature.</p>
        <div class="ce-order-list" cdkDropList (cdkDropListDropped)="reorderPhotos($event)">
          <div class="ce-order-item" *ngFor="let url of thumbnailUrls; let i = index" cdkDrag>
            <mat-icon class="ce-drag-handle">drag_indicator</mat-icon>
            <img [src]="url" alt="photo {{i + 1}}">
            <span>Photo {{i + 1}}</span>
          </div>
        </div>
      </section>
    </aside>

    <section class="ce-stage">
      <p class="ce-stage-hint" *ngIf="!generating">
        <mat-icon>pan_tool</mat-icon>
        Drag a cropped photo on the canvas to show a different part of it (e.g. if a face is cut off).
      </p>
      <div class="canvas-wrap" [class.is-loading]="generating">
        <canvas #collageCanvas></canvas>
        <mat-spinner *ngIf="generating" diameter="36"></mat-spinner>
      </div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="ce-actions">
    <span class="ce-dims" *ngIf="!generating">
      Exports at {{widthPx}} × {{exportHeightPx}} px<ng-container *ngIf="exportHeightPx < heightPx"> — the blank canvas below the photos is trimmed off</ng-container>
    </span>
    <span class="ce-spacer"></span>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="generating" (click)="useCollage()">
      <mat-icon>check</mat-icon> Use this collage
    </button>
  </mat-dialog-actions>
</div>
